export const BRAND_NAME = 'UniExch';
// Note: It is the main site url. Ex - sky11.com, etc.
export const BRAND_DOMAIN = 'uniexch.live';
export const PROVIDER_ID = 'BetFair';
